import { Input, Modal } from 'antd'

type InternalMemoryModalProps = {
  open: boolean
  value: string
  isSaving: boolean
  onChange: (value: string) => void
  onCancel: () => void
  onSave: () => void
}

export function InternalMemoryModal({ open, value, isSaving, onChange, onCancel, onSave }: InternalMemoryModalProps) {
  return (
    <Modal
      title="Industry and Profile"
      open={open}
      onCancel={onCancel}
      onOk={onSave}
      okText="Save"
      confirmLoading={isSaving}
    >
      <Input.TextArea
        value={value}
        onChange={(event) => onChange(event.target.value)}
        rows={10}
        placeholder="Add industry and profile details for this organisation"
      />
    </Modal>
  )
}
